import { render, staticRenderFns } from "./FollowPrompt.vue?vue&type=template&id=0cceee9f&scoped=true&"
import script from "./FollowPrompt.vue?vue&type=script&lang=js&"
export * from "./FollowPrompt.vue?vue&type=script&lang=js&"
import style0 from "./FollowPrompt.vue?vue&type=style&index=0&id=0cceee9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cceee9f",
  null
  
)

export default component.exports